import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { card } from "./ui";

export default function Pipeline() {
  const [data, setData] = useState(null);
  const [drag, setDrag] = useState(null);

  const load = () => api.get("/admin/pipeline").then(({ data }) => setData(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const move = async (id, stage) => {
    await api.patch(`/admin/enquiries/${id}`, { stage });
    load();
  };
  const onDrop = (stage) => { if (drag) { move(drag, stage); setDrag(null); } };

  if (!data) return <p className="text-ivory/40">Loading pipeline…</p>;

  return (
    <div data-testid="admin-pipeline">
      <p className="text-gold/70 text-xs tracking-[0.25em] uppercase">Event Pipeline</p>
      <h1 className="font-serif text-4xl text-ivory mt-1 mb-6">Drag cards to update stage.</h1>
      <div className="flex gap-4 overflow-x-auto pb-4 dark-scroll">
        {data.stages.map((stage) => (
          <div key={stage} onDragOver={(e) => e.preventDefault()} onDrop={() => onDrop(stage)}
            className={`${card} w-72 shrink-0 flex flex-col`} data-testid={`pipeline-col-${stage.replace(/ /g, "-")}`}>
            <div className="p-3.5 border-b border-white/5 flex items-center justify-between">
              <span className="text-gold text-xs tracking-wide uppercase">{stage}</span>
              <span className="text-ivory/40 text-xs">{data.columns[stage]?.length || 0}</span>
            </div>
            <div className="p-3 space-y-2 min-h-[120px]">
              {(data.columns[stage] || []).map((e) => (
                <div key={e.id} draggable onDragStart={() => setDrag(e.id)}
                  className="bg-[#1C1210] border border-gold/10 rounded-lg p-3 cursor-grab active:cursor-grabbing hover:border-gold/30">
                  <p className="text-ivory text-sm">{e.name}</p>
                  <p className="text-ivory/40 text-xs">{e.event_type} · {e.guests || "?"} guests</p>
                  <p className="text-gold/60 text-[0.68rem] mt-1">{e.event_date}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
